import { createPromiseClient, Transport } from '@bufbuild/connect';
import { createConnectTransport } from '@bufbuild/connect-web';

import { AgentService } from '@/shared/api/protocol-ts/api/agent/svc_agent_connectweb';
import { Authentication } from '@/shared/api/protocol-ts/api/auth/svc_authentication_connectweb';
import { Billing } from '@/shared/api/protocol-ts/api/billing_new/svc_billing_new_connectweb';
import { AccessService } from '@/shared/api/protocol-ts/api/core/svc_access_connectweb.ts';
import { AlbumService } from '@/shared/api/protocol-ts/api/core/svc_album_connectweb.ts';
import { AssetService } from '@/shared/api/protocol-ts/api/core/svc_asset_connectweb.ts';
import { OrganizationService } from '@/shared/api/protocol-ts/api/core/svc_organization_connectweb.ts';
import { PatientService } from '@/shared/api/protocol-ts/api/core/svc_patient_connectweb.ts';
import { PatientDocumentService } from '@/shared/api/protocol-ts/api/core/svc_patient_document_connectweb.ts';
import { PatientTaskService } from '@/shared/api/protocol-ts/api/core/svc_patient_task_connectweb.ts';
import { ReportService } from '@/shared/api/protocol-ts/api/core/svc_report_connectweb.ts';
import { StudyService } from '@/shared/api/protocol-ts/api/core/svc_study_connectweb.ts';
import { StorageService } from '@/shared/api/protocol-ts/api/core/svc_upload_connectweb.ts';
import { UserService } from '@/shared/api/protocol-ts/api/core/svc_user_connectweb';
import { IntegrationService } from '@/shared/api/protocol-ts/api/marketing/svc_integration_connectweb.ts';
import { QuestionnaireService } from '@/shared/api/protocol-ts/api/marketing/svc_questionnaire_connectweb.ts';
import { Notifications } from '@/shared/api/protocol-ts/api/notifications/svc_notifications_connectweb.ts';
import { AnalyticsModelService } from '@/shared/api/protocol-ts/api/scribe/svc_analytics_model_connectweb.ts';
import { DocumentTemplateService } from '@/shared/api/protocol-ts/api/scribe/svc_document_template_connectweb.ts';
import { EncounterService } from '@/shared/api/protocol-ts/api/scribe/svc_encounter_connectweb.ts';
import { EncounterSchemaService } from '@/shared/api/protocol-ts/api/scribe/svc_encounter_schema_connectweb.ts';
import { RegistryService } from '@/shared/api/protocol-ts/api/scribe/svc_registry_connectweb.ts';
import { BASE_URI, ENVIRONMENT } from '@/shared/config/config';

import { traceIdInterceptor } from './traceIdInterceptor';

const debug = ['staging', 'development'].includes(ENVIRONMENT);

const transport: Transport = createConnectTransport({
  baseUrl: BASE_URI || `https://${window.location.host}/`,
  useBinaryFormat: !(debug || false),
  credentials: 'include',
  interceptors: [traceIdInterceptor],
});

const api = {
  user: createPromiseClient(UserService, transport),
  access: createPromiseClient(AccessService, transport),
  patient: createPromiseClient(PatientService, transport),
  patientDocument: createPromiseClient(PatientDocumentService, transport),
  patientTask: createPromiseClient(PatientTaskService, transport),
  billing: createPromiseClient(Billing, transport),
  notifications: createPromiseClient(Notifications, transport),
  report: createPromiseClient(ReportService, transport),
  organization: createPromiseClient(OrganizationService, transport),
  // StorageServiceClientImpl contains the study entity
  storage: createPromiseClient(StorageService, transport),
  study: createPromiseClient(StudyService, transport),
  auth: createPromiseClient(Authentication, transport),
  assets: createPromiseClient(AssetService, transport),
  marketing: createPromiseClient(QuestionnaireService, transport),
  hubspot: createPromiseClient(IntegrationService, transport),
  album: createPromiseClient(AlbumService, transport),
  agent: createPromiseClient(AgentService, transport),
  documentTemplate: createPromiseClient(DocumentTemplateService, transport),
  encounter: createPromiseClient(EncounterService, transport),
  encounterSchema: createPromiseClient(EncounterSchemaService, transport),
  analyticsModel: createPromiseClient(AnalyticsModelService, transport),
  registry: createPromiseClient(RegistryService, transport),
};

export type ApiServices = keyof typeof api;
export default api;
